<template>
  <div>
    <div v-if="true"  class="uk-flex uk-flex-between uk-flex-top" style="padding:10px 10px 10px 40px;">
      <!-- 异常次数 -->
      <div class="border" style="width:46%">
        <div style="text-align: center;" class="bd-b pd-10">
          {{$t('integration.number_of_exceptions')}}
          <el-popover
            placement="bottom"
            width="150"
            trigger="hover"
          >
            <el-checkbox @change="filterNumAlarmChange" v-model="exNum.alarm" :label="$t('public.filter_invalid_info')" :true-label="1" :false-label="0"></el-checkbox>
            <i class="iconfont icon-shaixuan cursor-pointer fr" slot="reference"></i>
          </el-popover>
        </div>
        <div style="position: relative;height:250px;" class="bd-b pd-10">
          <!-- 直接统计显示饼图 -->
          <pieEchart v-if="exNum.dataType === 1 && exNumList.length" :chartData="setPieEchartData()"/>
          <!-- 同比和环比显示柱状图 -->
          <BarEchart v-if="exNum.dataType !== 1 && exNum.computedDataList.length"
            style="margin-left:30px;"
           :chartData="setBarEchartData()"/>

          <div class="btns uk-flex uk-flex-column">
            <el-button :type="exNum.type === 1 ? 'primary' : ''"
              :disabled="exNum.dataType !== 1"
               @click="changeNumberType(1)">
              {{ $t('integration.day') }}
            </el-button>
            <el-button :type="exNum.type === 2 ? 'primary' : ''" @click="changeNumberType(2)">{{ $t('integration.month') }}</el-button>
            <el-button :type="exNum.type === 3 ? 'primary' : ''" @click="changeNumberType(3)">{{ $t('integration.quarter') }}</el-button>
            <el-button :type="exNum.type === 4 ? 'primary' : ''" @click="changeNumberType(4)">{{ $t('integration.year') }}</el-button>

          </div>

        </div>
        <div class="bd-b pd-10">
          <el-radio-group v-model="exNum.dataType" @change="changNumberDataType">
          <el-radio :label="1">{{ $t('integration.direct_statistics') }}</el-radio>
          <el-radio :label="2"
            :disabled="exNum.type === 1">
            {{ $t('integration.year_on_year') }}{{ $t('integration.data') }}
          </el-radio>
          <el-radio :label="3"
            :disabled="exNum.type === 1">
            {{ $t('integration.month_on_month') }}{{ $t('integration.data') }}
          </el-radio>
        </el-radio-group>
        </div>
        <div class="pd-10">
          <!-- 直接统计时右边table的显示 -->
          <div v-if="exNum.dataType === 1">
            <template v-if="exNum.type === 1">
              <el-date-picker
                v-model="exNum.timeParams.day"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:100%;"
                :clearable="false"
                @change="changeNumberTime">
              </el-date-picker>
            </template>
            <template v-else-if="exNum.type === 2">
              <el-date-picker
                v-model="exNum.timeParams.month"
                type="month"
                :format="`yyyy${$t('integration.year')}MM${$t('integration.month')}`"
                value-format="yyyy-MM"
                style="width:100%;"
                :clearable="false"
                @change="changeNumberTime">
              </el-date-picker>
            </template>
            <template v-else-if="exNum.type === 3">
              <div>
                <el-select v-model="exNum.timeParams.quarterYear" style="width:40%;" class="mr-5" @change="changeNumberTime">
                  <el-option
                    v-for="item in yearList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="exNum.timeParams.quarter" style="width:55%;" @change="changeNumberTime">
                  <el-option
                    v-for="item in quarterList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </template>
            <template v-else>
              <el-select v-model="exNum.timeParams.year" style="width:100%;" @change="changeNumberTime">
                  <el-option
                    v-for="item in yearList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </template>
            <div class="mt-10" style="height:180px; overflow: auto;">
              <div v-if="exNumList.length" class="border">
                <el-row v-for="(item,index) in exNumList" :key="index">
                  <el-col :span="8" class="bd-r">{{ abnormalTypeConvert(item.exCatalog) }}</el-col>
                  <el-col :span="16">{{ item.num}}</el-col>
                </el-row>
                <!-- 异常最高温/湿度和最低温/湿度-->
                <template v-if="exNumMaxMin">
                  <el-row>
                    <el-col :span="8" class="bd-r">{{ $t('public.ex_max_temp_hum') }}</el-col>
                    <el-col :span="16">
                      <span v-if="exNumMaxMin.tempMax">{{ formatTempValue(exNumMaxMin.tempMax)}}{{tempUnit}}</span>
                      <span v-if="exNumMaxMin.tempMax && exNumMaxMin.humMax"> / </span>
                      <span v-if="exNumMaxMin.humMax">{{ exNumMaxMin.humMax}}%RH</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8" class="bd-r">{{ $t('public.ex_min_temp_hum') }}</el-col>
                    <el-col :span="16">
                      <span v-if="exNumMaxMin.tempMin">{{ formatTempValue(exNumMaxMin.tempMin) }}{{tempUnit}}</span>
                      <span v-if="exNumMaxMin.tempMin && exNumMaxMin.humMin"> / </span>
                      <span v-if="exNumMaxMin.humMin">{{ exNumMaxMin.humMin}}%RH</span>
                    </el-col>
                  </el-row>
                </template>
              </div>
              <el-empty v-else :description="$t('public.no_data')" :image-size="50"></el-empty>
            </div>

          </div>
          <div v-else>
            <!-- 同比数据时 -->
            <div v-if="exNum.dataType === 2">
              <!-- 月：同比 -->
              <template v-if="exNum.type === 2">
                <div>{{$t('integration.statistics')}}
                  <el-date-picker
                    v-model="exNum.timeParams.month"
                    type="month"
                    :format="`yyyy${$t('integration.year')}MM${$t('integration.month')}`"
                    value-format="yyyy-MM"
                    style="width:80%;"
                    :clearable="false"
                    @change="changeNumberComputed">
                  </el-date-picker>
                </div>
                <div class="mt-5">{{$t('integration.year_on_year')}}
                  <el-select v-model="exNum.computedParams.computedYear" style="width:70%;" @change="changeNumberTimeComputedYear">
                    <el-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  {{ exNum.computedParams.computedMonth }} {{$t('integration.month')}}
                </div>
              </template>
              <!-- 季度：同比 -->
              <template v-else-if="exNum.type === 3">
                <div>{{$t('integration.statistics')}}
                  <el-select v-model="exNum.timeParams.quarterYear" style="width:30%;" class="mr-5" @change="changeNumberComputed">
                    <el-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      >
                    </el-option>
                  </el-select>
                  <el-select v-model="exNum.timeParams.quarter" style="width:40%;" @change="changeNumberComputed">
                    <el-option
                      v-for="item in quarterList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="mt-5">{{$t('integration.year_on_year')}}
                  <el-select v-model="exNum.computedParams.computedQuarterYear" style="width:30%;" @change="changeNumberTimeComputedYear">
                    <el-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="item.value === exNum.timeParams.quarterYear">
                    </el-option>
                  </el-select>
                  {{ exNum.computedParams.computedQuarter == 1 ? $t('integration.one_quarter') :
                    ( exNum.computedParams.computedQuarter == 2 ? $t('integration.two_quarter') :
                    ( exNum.computedParams.computedQuarter == 3 ?  $t('integration.three_quarter'):  $t('integration.four_quarter')) )}}

                </div>
              </template>

               <!-- 年：同比 -->
              <template v-else>
                <div>{{$t('integration.statistics')}}
                  <el-select v-model="exNum.timeParams.year" style="width:80%;" @change="changeNumberComputed">
                    <el-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="mt-5">{{$t('integration.year_on_year')}}
                  {{ exNum.computedParams.computedYear }} {{$t('integration.year')}}
                </div>
              </template>

            </div>

            <!-- 环比数据时 -->
            <div v-else>
              <!-- 月：环比 -->
              <template v-if="exNum.type === 2">
                <div>{{$t('integration.statistics')}}
                  <el-date-picker
                    v-model="exNum.timeParams.month"
                    type="month"
                    :format="`yyyy${$t('integration.year')}MM${$t('integration.month')}`"
                    value-format="yyyy-MM"
                    style="width:80%;"
                    :clearable="false"
                    @change="changeNumberComputed">
                  </el-date-picker>
                </div>
                <div class="mt-5">{{$t('integration.month_on_month')}}
                  {{ exNum.computedParams.computedYear }} {{$t('integration.year')}}
                  {{ exNum.computedParams.computedMonth }} {{$t('integration.month')}}
                </div>
              </template>
              <!-- 季度：环比 -->
              <template v-else-if="exNum.type === 3">
                <div>{{$t('integration.statistics')}}
                  <el-select v-model="exNum.timeParams.quarterYear" style="width:30%;" class="mr-5" @change="changeNumberComputed">
                    <el-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      >
                    </el-option>
                  </el-select>
                  <el-select v-model="exNum.timeParams.quarter" style="width:40%;" @change="changeNumberComputed">
                    <el-option
                      v-for="item in quarterList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="mt-5">{{$t('integration.month_on_month')}}
                  {{ exNum.computedParams.computedQuarterYear }} {{$t('integration.year')}}
                 {{ exNum.computedParams.computedQuarter == 1 ? $t('integration.one_quarter') :
                    ( exNum.computedParams.computedQuarter == 2 ? $t('integration.two_quarter') :
                    ( exNum.computedParams.computedQuarter == 3 ?  $t('integration.three_quarter'):  $t('integration.four_quarter')) )}}

                </div>
              </template>
               <!-- 年：环比 -->
                <template v-else>
                  <div>{{$t('integration.statistics')}}
                    <el-select v-model="exNum.timeParams.year" style="width:80%;" @change="changeNumberComputed">
                      <el-option
                        v-for="item in yearList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="mt-5">{{$t('integration.month_on_month')}}
                    {{ exNum.computedParams.computedYear }} {{$t('integration.year')}}
                  </div>
                </template>
            </div>

            <el-table
                :data="exNum.computedDataList"
                :key="exNum.isUpdate"
                border
                ref="computedTable"
                style="margin-top:10px;"
              >
                <el-table-column
                  :label="$t('public.exception')"
                  >
                  <template  slot-scope="scope">
                    <span>{{ abnormalTypeConvert(scope.row.exCatalog) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  v-for="(item, index) in exNum.computedDynamicColumns"
                  :key="index"
                  width="200"
                >
                  <template slot="header">
                    <span>{{ item }}</span>
                  </template>
                  <template  slot-scope="scope">
                    <span v-if="!scope.row.countList[index] || !scope.row.countList[index].num"> - </span>
                    <span v-else>
                      {{ scope.row.countList[index].num }}
                    </span>
                  </template>

                </el-table-column>
                <!-- append -->
                <div slot="append" v-if="exNumComputedDataMaxMin">
                  <div class="uk-flex uk-flex-between">
                    <div style="flex:1;" class="my-td">{{ $t('public.ex_max_temp_hum') }}</div>
                    <div style="width: 200px; box-sizing: border-box;" class="my-td">
                      <span v-if="exNumComputedDataMaxMin.countList[0].tempMax">{{ formatTempValue(exNumComputedDataMaxMin.countList[0].tempMax)}}{{tempUnit}}</span>
                      <span v-if="exNumComputedDataMaxMin.countList[0].tempMax && exNumComputedDataMaxMin.countList[0].humMax"> / </span>
                      <span v-if="exNumComputedDataMaxMin.countList[0].humMax">{{ exNumComputedDataMaxMin.countList[0].humMax}}%RH</span>
                    </div>
                    <div style="width: 200px; box-sizing: border-box;" class="my-td">
                      <span v-if="exNumComputedDataMaxMin.countList[1].tempMax">{{ exNumComputedDataMaxMin.countList[1].tempMax}}</span>
                      <span v-if="exNumComputedDataMaxMin.countList[1].tempMax && exNumComputedDataMaxMin.countList[1].humMax"> / </span>
                      <span v-if="exNumComputedDataMaxMin.countList[1].humMax">{{ exNumComputedDataMaxMin.countList[1].humMax}}%RH</span>
                    </div>
                  </div>
                  <div class="uk-flex">
                    <div style="flex:1;" class="my-td">{{ $t('public.ex_min_temp_hum') }}</div>
                    <div style="width: 200px; box-sizing: border-box;" class="my-td">
                      <span v-if="exNumComputedDataMaxMin.countList[0].tempMin">{{ formatTempValue(exNumComputedDataMaxMin.countList[0].tempMin)}}{{tempUnit}}</span>
                      <span v-if="exNumComputedDataMaxMin.countList[0].tempMin && exNumComputedDataMaxMin.countList[0].humMin"> / </span>
                      <span v-if="exNumComputedDataMaxMin.countList[0].humMin">{{ exNumComputedDataMaxMin.countList[0].humMin}}%RH</span>
                    </div>
                    <div style="width: 200px; box-sizing: border-box;" class="my-td">
                      <span v-if="exNumComputedDataMaxMin.countList[1].tempMin">{{formatTempValue( exNumComputedDataMaxMin.countList[1].tempMin)}}{{tempUnit}}</span>
                      <span v-if="exNumComputedDataMaxMin.countList[1].tempMin && exNumComputedDataMaxMin.countList[1].humMin"> / </span>
                      <span v-if="exNumComputedDataMaxMin.countList[1].humMin">{{ exNumComputedDataMaxMin.countList[1].humMin}}%RH</span>
                    </div>
                  </div>
                </div>
              </el-table>

          </div>

        </div>
        <el-button type="primary" style="width:100%;margin-top:20px;" @click="handleDetail('num')">{{ $t('public.detail')}}</el-button>
      </div>

       <!-- 异常时间 -->
      <div class="border" style="width:46%">
        <div style="text-align: center;" class="bd-b pd-10">
          {{$t('integration.abnormal_time')}}
          <el-popover
            placement="bottom"
            width="150"
            trigger="hover"
          >
            <el-checkbox @change="filterTimeAlarmChange" v-model="exTime.alarm" :label="$t('public.filter_invalid_info')" :true-label="1" :false-label="0"></el-checkbox>
            <i class="iconfont icon-shaixuan cursor-pointer fr" slot="reference"></i>
          </el-popover>
        </div>
        <div style="position: relative;height:250px;" class="bd-b pd-10">
          <!-- 直接统计显示饼图 -->
          <pieEchart v-if="exTime.dataType === 1 && exTimeList.length" :chartData="setPieEchartData2()"/>
          <!-- 同比和环比显示柱状图 -->
          <BarEchart v-if="exTime.dataType !== 1 && exTime.computedDataList.length"
            style="margin-left:30px;"
           :chartData="setBarEchartData2()"/>

          <div class="btns uk-flex uk-flex-column">
            <el-button :type="exTime.type === 1 ? 'primary' : ''"
              :disabled="exTime.dataType !== 1"
               @click="changeTimeType(1)">
              {{ $t('integration.day') }}
            </el-button>
            <el-button :type="exTime.type === 2 ? 'primary' : ''" @click="changeTimeType(2)">{{ $t('integration.month') }}</el-button>
            <el-button :type="exTime.type === 3 ? 'primary' : ''" @click="changeTimeType(3)">{{ $t('integration.quarter') }}</el-button>
            <el-button :type="exTime.type === 4 ? 'primary' : ''" @click="changeTimeType(4)">{{ $t('integration.year') }}</el-button>

          </div>

        </div>
        <div class="bd-b pd-10">
          <el-radio-group v-model="exTime.dataType" @change="changTimeDataType">
          <el-radio :label="1">{{ $t('integration.direct_statistics') }}</el-radio>
          <el-radio :label="2"
            :disabled="exTime.type === 1">
            {{ $t('integration.year_on_year') }}{{ $t('integration.data') }}
          </el-radio>
          <el-radio :label="3"
            :disabled="exTime.type === 1">
            {{ $t('integration.month_on_month') }}{{ $t('integration.data') }}
          </el-radio>
        </el-radio-group>
        </div>
        <div class="pd-10">
          <!-- 直接统计时右边table的显示 -->
          <div v-if="exTime.dataType === 1">
            <template v-if="exTime.type === 1">
              <el-date-picker
                v-model="exTime.timeParams.day"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:100%;"
                :clearable="false"
                @change="changeTimeTime">
              </el-date-picker>
            </template>
            <template v-else-if="exTime.type === 2">
              <el-date-picker
                v-model="exTime.timeParams.month"
                type="month"
                :format="`yyyy${$t('integration.year')}MM${$t('integration.month')}`"
                value-format="yyyy-MM"
                style="width:100%;"
                :clearable="false"
                @change="changeTimeTime">
              </el-date-picker>
            </template>
            <template v-else-if="exTime.type === 3">
              <div>
                <el-select v-model="exTime.timeParams.quarterYear" style="width:40%;" class="mr-5" @change="changeTimeTime">
                  <el-option
                    v-for="item in yearList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="exTime.timeParams.quarter" style="width:55%;" @change="changeTimeTime">
                  <el-option
                    v-for="item in quarterList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </template>
            <template v-else>
              <el-select v-model="exTime.timeParams.year" style="width:100%;" @change="changeTimeTime">
                  <el-option
                    v-for="item in yearList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </template>
            <div class="mt-10" style="height:180px; overflow: auto;">
              <div v-if="exTimeList.length" class="border">
                <el-row v-for="(item,index) in exTimeList" :key="index">
                  <el-col :span="8" class="bd-r">{{ abnormalTypeConvert(item.exCatalog) }}</el-col>
                  <el-col :span="16">{{ formatSeconds(item.time / 1000)}}</el-col>
                </el-row>
                <!-- 异常最高温/湿度和最低温/湿度和持续时间-->
                <template v-if="exTimeMaxMin">
                  <el-row>
                    <el-col :span="8" class="bd-r">{{ $t('public.ex_max_temp_hum') }}</el-col>
                    <el-col :span="16">
                      <span v-if="exTimeMaxMin.tempMax">{{ exTimeMaxMin.tempMax}}°C</span>
                      <span v-if="exTimeMaxMin.tempMax && exTimeMaxMin.humMax"> / </span>
                      <span v-if="exTimeMaxMin.humMax">{{ exTimeMaxMin.humMax}}%RH</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8" class="bd-r">{{ $t('public.ex_min_temp_hum') }}</el-col>
                    <el-col :span="16">
                      <span v-if="exTimeMaxMin.tempMin">{{ exTimeMaxMin.tempMin}}°C</span>
                      <span v-if="exTimeMaxMin.tempMin && exTimeMaxMin.humMin"> / </span>
                      <span v-if="exTimeMaxMin.humMin">{{ exTimeMaxMin.humMin}}%RH</span>
                    </el-col>
                  </el-row>
                  <!-- 温度/湿度异常持续时间 -->
                  <el-row>
                    <el-col :span="8" class="bd-r">{{ $t('public.ex_duration_temp') }}</el-col>
                    <el-col :span="16" v-if="exTimeMaxMin.tempTimeMax">{{ formatSeconds(exTimeMaxMin.tempTimeMax / 1000)}}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8" class="bd-r">{{ $t('public.ex_duration_hum') }}</el-col>
                    <el-col :span="16" v-if="exTimeMaxMin.humTimeMax">{{ formatSeconds(exTimeMaxMin.humTimeMax / 1000)}}</el-col>
                  </el-row>
                </template>
                <!-- 异常次数里面的离线持续最长时间-->
                <template v-if="exTimeOfflineMax">
                  <el-row>
                    <el-col :span="8" class="bd-r">{{ $t('public.ex_duration_offline') }}</el-col>
                    <el-col :span="16" v-if="exTimeOfflineMax.timeMax">{{ formatSeconds(exTimeOfflineMax.timeMax / 1000)}}</el-col>
                  </el-row>
                </template>
                <!-- 异常次数里面的断电持续最长时间-->
                <template v-if="exTimePowerMax">
                  <el-row>
                    <el-col :span="8" class="bd-r">{{ $t('public.ex_duration_power') }}</el-col>
                    <el-col :span="16" v-if="exTimePowerMax.timeMax">{{ formatSeconds(exTimePowerMax.timeMax / 1000)}}</el-col>
                  </el-row>
                </template>
              </div>
              <el-empty v-else :description="$t('public.no_data')" :image-size="50"></el-empty>
            </div>

          </div>
          <div v-else>
            <!-- 同比数据时 -->
            <div v-if="exTime.dataType === 2">
              <!-- 月：同比 -->
              <template v-if="exTime.type === 2">
                <div>{{$t('integration.statistics')}}
                  <el-date-picker
                    v-model="exTime.timeParams.month"
                    type="month"
                    :format="`yyyy${$t('integration.year')}MM${$t('integration.month')}`"
                    value-format="yyyy-MM"
                    style="width:80%;"
                    :clearable="false"
                    @change="changeTimeComputed">
                  </el-date-picker>
                </div>
                <div class="mt-5">{{$t('integration.year_on_year')}}
                  <el-select v-model="exTime.computedParams.computedYear" style="width:70%;" @change="changeNumberTimeComputedYear">
                    <el-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  {{ exTime.computedParams.computedMonth }} {{$t('integration.month')}}
                </div>
              </template>
              <!-- 季度：同比 -->
              <template v-else-if="exTime.type === 3">
                <div>{{$t('integration.statistics')}}
                  <el-select v-model="exTime.timeParams.quarterYear" style="width:30%;" class="mr-5" @change="changeTimeComputed">
                    <el-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      >
                    </el-option>
                  </el-select>
                  <el-select v-model="exTime.timeParams.quarter" style="width:40%;" @change="changeTimeComputed">
                    <el-option
                      v-for="item in quarterList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="mt-5">{{$t('integration.year_on_year')}}
                  <el-select v-model="exTime.computedParams.computedQuarterYear" style="width:30%;" @change="changeNumberTimeComputedYear">
                    <el-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="item.value === exTime.timeParams.quarterYear">
                    </el-option>
                  </el-select>
                  {{ exTime.computedParams.computedQuarter == 1 ? $t('integration.one_quarter') :
                    ( exTime.computedParams.computedQuarter == 2 ? $t('integration.two_quarter') :
                    ( exTime.computedParams.computedQuarter == 3 ?  $t('integration.three_quarter'):  $t('integration.four_quarter')) )}}

                </div>
              </template>

               <!-- 年：同比 -->
              <template v-else>
                <div>{{$t('integration.statistics')}}
                  <el-select v-model="exTime.timeParams.year" style="width:80%;" @change="changeTimeComputed">
                    <el-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="mt-5">{{$t('integration.year_on_year')}}
                  {{ exTime.computedParams.computedYear }} {{$t('integration.year')}}
                </div>
              </template>

            </div>

            <!-- 环比数据时 -->
            <div v-else>
              <!-- 月：环比 -->
              <template v-if="exTime.type === 2">
                <div>{{$t('integration.statistics')}}
                  <el-date-picker
                    v-model="exTime.timeParams.month"
                    type="month"
                    :format="`yyyy${$t('integration.year')}MM${$t('integration.month')}`"
                    value-format="yyyy-MM"
                    style="width:80%;"
                    :clearable="false"
                    @change="changeTimeComputed">
                  </el-date-picker>
                </div>
                <div class="mt-5">{{$t('integration.month_on_month')}}
                  {{ exTime.computedParams.computedYear }} {{$t('integration.year')}}
                  {{ exTime.computedParams.computedMonth }} {{$t('integration.month')}}
                </div>
              </template>
              <!-- 季度：环比 -->
              <template v-else-if="exTime.type === 3">
                <div>{{$t('integration.statistics')}}
                  <el-select v-model="exTime.timeParams.quarterYear" style="width:30%;" class="mr-5" @change="changeTimeComputed">
                    <el-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      >
                    </el-option>
                  </el-select>
                  <el-select v-model="exTime.timeParams.quarter" style="width:40%;" @change="changeTimeComputed">
                    <el-option
                      v-for="item in quarterList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <div class="mt-5">{{$t('integration.month_on_month')}}
                  {{ exTime.computedParams.computedQuarterYear }} {{$t('integration.year')}}
                  {{ exTime.computedParams.computedQuarter == 1 ? $t('integration.one_quarter') :
                    ( exTime.computedParams.computedQuarter == 2 ? $t('integration.two_quarter') :
                    ( exTime.computedParams.computedQuarter == 3 ?  $t('integration.three_quarter'):  $t('integration.four_quarter')) )}}

                </div>
              </template>
               <!-- 年：环比 -->
                <template v-else>
                  <div>{{$t('integration.statistics')}}
                    <el-select v-model="exTime.timeParams.year" style="width:80%;" @change="changeTimeComputed">
                      <el-option
                        v-for="item in yearList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="mt-5">{{$t('integration.month_on_month')}}
                    {{ exTime.computedParams.computedYear }} {{$t('integration.year')}}
                  </div>
                </template>
            </div>

            <div style="height:180px; overflow: auto;">
              <el-table
                :data="exTime.computedDataList"
                :key="exTime.isUpdate"
                border
                ref="computedTable"
                style="margin-top:10px;"
              >
                <el-table-column
                  :label="$t('public.exception')"
                  >
                  <template  slot-scope="scope">
                    <span>{{ abnormalTypeConvert(scope.row.exCatalog) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  v-for="(item, index) in exTime.computedDynamicColumns"
                  :key="index"
                  width="180"
                >
                  <template slot="header">
                    <span>{{ item }}</span>
                  </template>
                  <template  slot-scope="scope">
                    <span v-if="!scope.row.countList[index] || !scope.row.countList[index].time"> - </span>
                    <span v-else>
                      {{ formatSeconds(scope.row.countList[index].time / 1000) }}
                    </span>
                  </template>
                </el-table-column>
                <!-- append -->
                <div slot="append">
                  <div v-if="exTimeComputedDataMaxMin">
                    <div class="uk-flex uk-flex-between">
                      <div style="flex:1;" class="my-td">{{ $t('public.ex_max_temp_hum') }}</div>
                      <div style="width: 180px; box-sizing: border-box;" class="my-td">
                        <span v-if="exTimeComputedDataMaxMin.countList[0].tempMax">{{ exTimeComputedDataMaxMin.countList[0].tempMax}}°C</span>
                        <span v-if="exTimeComputedDataMaxMin.countList[0].tempMax && exTimeComputedDataMaxMin.countList[0].humMax"> / </span>
                        <span v-if="exTimeComputedDataMaxMin.countList[0].humMax">{{ exTimeComputedDataMaxMin.countList[0].humMax}}%RH</span>
                      </div>
                      <div style="width: 180px; box-sizing: border-box;" class="my-td">
                        <span v-if="exTimeComputedDataMaxMin.countList[1].tempMax">{{ exTimeComputedDataMaxMin.countList[1].tempMax}}°C</span>
                        <span v-if="exTimeComputedDataMaxMin.countList[1].tempMax && exTimeComputedDataMaxMin.countList[1].humMax"> / </span>
                        <span v-if="exTimeComputedDataMaxMin.countList[1].humMax">{{ exTimeComputedDataMaxMin.countList[1].humMax}}%RH</span>
                      </div>
                    </div>
                    <div class="uk-flex">
                      <div style="flex:1;" class="my-td">{{ $t('public.ex_min_temp_hum') }}</div>
                      <div style="width: 180px; box-sizing: border-box;" class="my-td">
                        <span v-if="exTimeComputedDataMaxMin.countList[0].tempMin">{{ exTimeComputedDataMaxMin.countList[0].tempMin}}°C</span>
                        <span v-if="exTimeComputedDataMaxMin.countList[0].tempMin && exTimeComputedDataMaxMin.countList[0].humMin"> / </span>
                        <span v-if="exTimeComputedDataMaxMin.countList[0].humMin">{{ exTimeComputedDataMaxMin.countList[0].humMin}}%RH</span>
                      </div>
                      <div style="width: 180px; box-sizing: border-box;" class="my-td">
                        <span v-if="exTimeComputedDataMaxMin.countList[1].tempMin">{{ exTimeComputedDataMaxMin.countList[1].tempMin}}°C</span>
                        <span v-if="exTimeComputedDataMaxMin.countList[1].tempMin && exTimeComputedDataMaxMin.countList[1].humMin"> / </span>
                        <span v-if="exTimeComputedDataMaxMin.countList[1].humMin">{{ exTimeComputedDataMaxMin.countList[1].humMin}}%RH</span>
                      </div>
                    </div>
                    <div class="uk-flex uk-flex-between">
                      <div style="flex:1;" class="my-td">{{ $t('public.ex_duration_temp') }}</div>
                      <div style="width: 180px; box-sizing: border-box;" class="my-td">
                        <span v-if="exTimeComputedDataMaxMin.countList[0].tempTimeMax">{{ formatSeconds(exTimeComputedDataMaxMin.countList[0].tempTimeMax/1000)}}</span>
                      </div>
                      <div style="width: 180px; box-sizing: border-box;" class="my-td">
                        <span v-if="exTimeComputedDataMaxMin.countList[1].tempTimeMax">{{ formatSeconds(exTimeComputedDataMaxMin.countList[1].tempTimeMax/1000)}}</span>
                      </div>
                    </div>
                    <div class="uk-flex">
                      <div style="flex:1;" class="my-td">{{ $t('public.ex_duration_hum') }}</div>
                      <div style="width: 180px; box-sizing: border-box;" class="my-td">
                        <span v-if="exTimeComputedDataMaxMin.countList[0].humTimeMax">{{ formatSeconds(exTimeComputedDataMaxMin.countList[0].humTimeMax/1000)}}</span>
                      </div>
                      <div style="width: 180px; box-sizing: border-box;" class="my-td">
                        <span v-if="exTimeComputedDataMaxMin.countList[1].humTimeMax">{{ formatSeconds(exTimeComputedDataMaxMin.countList[1].humTimeMax/1000)}}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="exTimeComputedDataOfflineMax">
                    <div class="uk-flex uk-flex-between">
                      <div style="flex:1;" class="my-td">{{ $t('public.ex_duration_offline') }}</div>
                      <div style="width: 180px; box-sizing: border-box;" class="my-td">
                        <span v-if="exTimeComputedDataOfflineMax.countList[0].timeMax">{{ formatSeconds(exTimeComputedDataOfflineMax.countList[0].timeMax/1000)}}</span>
                      </div>
                      <div style="width: 180px; box-sizing: border-box;" class="my-td">
                        <span v-if="exTimeComputedDataOfflineMax.countList[1].timeMax">{{ formatSeconds(exTimeComputedDataOfflineMax.countList[1].timeMax/1000)}}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="exTimeComputedDataPowerMax">
                    <div class="uk-flex uk-flex-between">
                      <div style="flex:1;" class="my-td">{{ $t('public.ex_duration_power') }}</div>
                      <div style="width: 180px; box-sizing: border-box;" class="my-td">
                        <span v-if="exTimeComputedDataPowerMax.countList[0].timeMax">{{ formatSeconds(exTimeComputedDataPowerMax.countList[0].timeMax/1000)}}</span>
                      </div>
                      <div style="width: 180px; box-sizing: border-box;" class="my-td">
                        <span v-if="exTimeComputedDataPowerMax.countList[1].timeMax">{{ formatSeconds(exTimeComputedDataPowerMax.countList[1].timeMax/1000)}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </el-table>
            </div>

          </div>

        </div>
        <el-button type="primary" style="width:100%;margin-top:20px;" @click="handleDetail('time')">{{ $t('public.detail')}}</el-button>
      </div>

    </div>
    <el-empty v-else :description="$t('public.no_data')"></el-empty>

    <AbnormalDetail v-if="isShowDetail" :isShow="isShowDetail"
     :sceneIds="sceneIds" :exType="exType"
     @close="isShowDetail = false"/>

  </div>
</template>

<script>
import pieEchart from '@/components/echart/pieEchart.vue';
import BarEchart from '@/components/echart/barEchart.vue';
import AbnormalDetail from '../abnormal/abnormalDetail.vue';
import { getExNumList, getExTimeList } from '@/api/modules/overview.js'
import { formatSeconds } from '@/utils/time';
import { shareUnit } from '../../../../api/modules/public'


export default {
  props: {
    sceneIds: {
      type: Array,
      default: () => []
    }
  },
  components: {
    pieEchart,
    AbnormalDetail,
    BarEchart
  },
  data(){
    return {
      tempUnit:'',
      exNumList: [], // 异常次数列表
      exTimeList: [], // 异常时间列表

      exNum: {
         type: 1,
         dataType: 1,
         timeParams: {
            day: new Date().getFullYear() + '-' + (parseInt(new Date().getMonth())+1) + '-' + new Date().getDate(),
            month: new Date().getFullYear() + '-' + (parseInt(new Date().getMonth())+1),
            year: new Date().getFullYear(),
            quarterYear: new Date().getFullYear(),
            quarter: 1
          },
        computedParams: {},

        computedDynamicColumns: [],

        computedDataList: [],

        isUpdate: false,

        alarm: 1, // 过滤无效信息标记
      },

      exTime: {
         type: 1,
         dataType: 1,
         timeParams: {
          day: new Date().getFullYear() + '-' + (parseInt(new Date().getMonth())+1) + '-' + new Date().getDate(),
          month: new Date().getFullYear() + '-' + (parseInt(new Date().getMonth())+1),
          year: new Date().getFullYear(),
          quarterYear: new Date().getFullYear(),
          quarter: 1
        },
        computedParams: {},

        computedDynamicColumns: [],

        computedDataList: [],

        isUpdate: false,

        alarm: 1, // 过滤无效信息标记
      },


      isShowDetail: false,

      formatSeconds,

      exType: 'num'

    }
  },
  created(){
    this.UnitMeasurementFn();
  },
  computed: {
    yearList(){
      let cur = new Date().getFullYear()
      let arr = []
      for(let i=cur; i>cur-5; i--){
        arr.push({
          value: i,
          label: i + this.$t('integration.year')
        })
      }
      return arr
    },
    // 季度
    quarterList(){
      let arr = []
      for(let i=1; i<5; i++){
        let label = ''
        switch (i){
          case 1:
            label = this.$t('integration.one_quarter')
            break
          case 2:
            label = this.$t('integration.two_quarter')
            break
          case 3:
            label = this.$t('integration.three_quarter')
            break
          case 4:
            label = this.$t('integration.four_quarter')
            break
        }
        arr.push({
          value: i,
          label: label
        })
      }
      return arr
    },
    // 有数据异常时才会有异常次数里面的异常最/低高温/湿度
    exNumMaxMin(){
      return this.exNumList.filter(_ => _.exCatalog === 1)[0]
    },
    // 异常次数里面的异常最/低高温/湿度和持续时间
    exTimeMaxMin(){
      return this.exTimeList.filter(_ => _.exCatalog === 1)[0]
    },
    // 异常次数里面的离线持续最长时间
    exTimeOfflineMax(){
      return this.exTimeList.filter(_ => _.exCatalog === 0)[0]
    },
    // 异常次数里面的断电持续最长时间
    exTimePowerMax(){
      return this.exTimeList.filter(_ => _.exCatalog === 2)[0]
    },
    // 同比/环比时异常次数里面的异常最/低高温/湿度
    exNumComputedDataMaxMin(){
      return this.exNum.computedDataList.filter(_ => _.exCatalog === 1)[0]
    },
    // 同比/环比时异常时间里面的异常最/低高温/湿度
    exTimeComputedDataMaxMin(){
      return this.exTime.computedDataList.filter(_ => _.exCatalog === 1)[0]
    },
    // 异常次数里面的离线持续最长时间
     exTimeComputedDataOfflineMax(){
      return this.exTime.computedDataList.filter(_ => _.exCatalog === 0)[0]
    },
    // 异常次数里面的断电持续最长时间
     exTimeComputedDataPowerMax(){
      return this.exTime.computedDataList.filter(_ => _.exCatalog === 2)[0]
    },

  },
  methods: {
    UnitMeasurementFn () {
      shareUnit().then(({ result }) => {
        this.tempUnit = result.find(item => item.code === 'temp')?.name ?? '';
      })
    },
    formatTempValue(val) {
      if (val === null || val === undefined || val === '') return '--'
      const numVal = Number(val)
      if (isNaN(numVal)) return '--'
      const result = TempUtils.convertToCelsius(numVal, this.tempUnit)
      const finalVal = isNaN(result) ? '--' : Number(result).toFixed(2)
      return `${finalVal}`
    },
    getData(){
      if(this.sceneIds && this.sceneIds.length){
        this.getExNum()
        this.getExTime()
      }else{
        this.exNumList = null
        this.exTimeList = null
      }
    },
    // 获取异常次数
    getExNum(){
      return new Promise((resolve, reject) => {
        let params = {
          scenes: this.sceneIds.join(),
          type: this.exNum.type,
          alarm: this.exNum.alarm
        }
        if(this.exNum.type === 1){
          params.time = this.exNum.timeParams.day
        }else if(this.exNum.type === 2){
          params.time = this.exNum.timeParams.month
        }else if(this.exNum.type === 3){
          params.time = this.exNum.timeParams.quarterYear + '-' + this.exNum.timeParams.quarter
        }else{
          params.time = this.exNum.timeParams.year
        }
        console.log('params=', params, this.exNum.timeParams)
        getExNumList(params).then(res => {
          if (res.state.code === 200) {
            this.exNumList = res.result
            resolve();
          }
        })
      })

    },
    // 获取异常时间
    getExTime(){
      return new Promise((resolve, reject) => {
        let params = {
          scenes: this.sceneIds.join(),
          type: this.exTime.type,
          alarm: this.exTime.alarm
        }
        if(this.exTime.type === 1){
          params.time = this.exTime.timeParams.day
        }else if(this.exTime.type === 2){
          params.time = this.exTime.timeParams.month
        }else if(this.exTime.type === 3){
          params.time = this.exTime.timeParams.quarterYear + '-' + this.exTime.timeParams.quarter
        }else{
          params.time = this.exTime.timeParams.year
        }
        console.log('params=', params, this.exTime.timeParams)
        getExTimeList(params).then(res => {
          if (res.state.code === 200) {
            this.exTimeList = res.result
            resolve();
          }
        })
      })

    },

    setPieEchartData(){
      // 整理构造饼图数据
      let pieSeries = []

      this.exNumList.forEach(item => {
        pieSeries.push({
            name: this.abnormalTypeConvert(item.exCatalog),
            value: item.num
          })
      })
      return {
        pieSeries,
        rest: {
          legend: {
              show: false
          },
          isTip: true,
          labelLine: {
              show: true
          },
          label: {
              show: true
          },
          title: '',
          name: ''
        }
      }
    },
    // 异常时间的饼图
    setPieEchartData2(){
      // 整理构造饼图数据
      let pieSeries = []

      this.exTimeList.forEach(item => {
        pieSeries.push({
            name: this.abnormalTypeConvert(item.exCatalog),
            value: item.time
          })
      })
      return {
        pieSeries,
        rest: {
          legend: {
              show: false
          },
          isTip: true,
          labelLine: {
              show: true
          },
          label: {
            show: true
          },
          title: '',
          name: '',

        },
        tooltip: {
          formatter: params => {
            return (
              params.name + ": " + this.formatSeconds(params.value / 1000)
            )
          }
        }
      }
    },
    setBarEchartData(){
      let data = []
      let barSeries = {
        xAxis: [],
        series: []
      }
      let arr1 = []
      let arr2 = []
      data = this.exNum.computedDataList
      barSeries.xAxis = this.exNum.computedDynamicColumns
      data.forEach(item => {
        let arr = []
        arr.push({
          name: this.abnormalTypeConvert(item.exCatalog),
          value: item.countList[0] ? item.countList[0].num : 0
        })
        arr.push({
          name: this.abnormalTypeConvert(item.exCatalog),
          value: item.countList[1] ? item.countList[1].num: 0
        })

        barSeries.series.push(arr)
      })
      console.log('barSeries=', barSeries)

      return {
        barSeries,
        rest: {
          legend: {
              show: false
          },
          isTip: true,
          labelLine: {
              show: true
          },
          label: {
              show: true
          },
          title: '',
          name: ''
        }
      }
    },
    // 异常时间的柱状图
    setBarEchartData2(){
      let data = []
      let barSeries = {
        xAxis: [],
        series: []
      }
      let arr1 = []
      let arr2 = []
      data = this.exTime.computedDataList
      barSeries.xAxis = this.exTime.computedDynamicColumns
      data.forEach(item => {
        let arr = []
         arr.push({
          name: this.abnormalTypeConvert(item.exCatalog),
          value: item.countList[0] ? item.countList[0].time : 0
        })
        arr.push({
          name: this.abnormalTypeConvert(item.exCatalog),
          value: item.countList[1] ? item.countList[1].time: 0
        })

        barSeries.series.push(arr)
      })
      console.log('barSeries=', barSeries)

      return {
        barSeries,
        rest: {
          legend: {
              show: false
          },
          isTip: true,
          labelLine: {
              show: true
          },
          label: {
              show: true
          },
          title: '',
          name: ''
        },
        tooltip: {
          formatter: params => {
            return (
              params.data.name + ": " + this.formatSeconds(params.data.value / 1000)
            )
          }
        }
      }
    },
    // 选择的数据模式改变
    changeNumberType(type){
      this.exNum.type = type
      if(this.exNum.dataType === 1){
        this.getExNum()
      }else{
        this.changNumberDataType()
      }
    },
    changeNumberTime(){
      this.getExNum()
    },
    // 直接统计/同比/环比改变
    async changNumberDataType(){
      if(this.exNum.dataType == 2 ){
        this.exNum.computedParams = JSON.parse(JSON.stringify(this.exNum.timeParams))

        if(this.exNum.type ===2){
          this.$set(this.exNum.computedParams, 'computedYear', parseInt(this.exNum.computedParams.month.split('-')[0]) - 1)
          this.$set(this.exNum.computedParams, 'computedMonth', this.exNum.computedParams.month.split('-')[1])
        }else if(this.exNum.type === 3){
          this.$set(this.exNum.computedParams, 'computedQuarterYear', this.exNum.computedParams.quarterYear - 1)
          this.$set(this.exNum.computedParams, 'computedQuarter', this.exNum.computedParams.quarter)
        }else{
          this.$set(this.exNum.computedParams, 'computedYear', this.exNum.computedParams.year - 1)
        }

      }else if(this.exNum.dataType == 3){
        this.exNum.computedParams = JSON.parse(JSON.stringify(this.exNum.timeParams))
        if(this.exNum.type ===2){
          // 如果是1月环比，就要和上一年的12月比
          if(parseInt(this.exNum.computedParams.month.split('-')[1]) ===  1){
            this.$set(this.exNum.computedParams, 'computedYear', parseInt(this.exNum.computedParams.month.split('-')[0]) - 1)
            this.$set(this.exNum.computedParams, 'computedMonth', 12)
          }else{
            this.$set(this.exNum.computedParams, 'computedYear', this.exNum.computedParams.month.split('-')[0])
            this.$set(this.exNum.computedParams, 'computedMonth', parseInt(this.exNum.computedParams.month.split('-')[1]) - 1)
          }

        }else if(this.exNum.type === 3){
          // 如果是第一季度环比，就是和上一年的第4季度比
          if(this.exNum.computedParams.quarter == 1){
            this.$set(this.exNum.computedParams, 'computedQuarterYear', this.exNum.computedParams.quarterYear - 1)
            this.$set(this.exNum.computedParams, 'computedQuarter', 4)
          }else{
            this.$set(this.exNum.computedParams, 'computedQuarterYear', this.exNum.computedParams.quarterYear)
            this.$set(this.exNum.computedParams, 'computedQuarter', this.exNum.computedParams.quarter - 1)
          }

        }else{
          this.$set(this.exNum.computedParams, 'computedYear', this.exNum.computedParams.year - 1)
        }
      }
      await this.getExNum()
      this.getNumberComputed()
    },
    // 获取对比的另一个数据
    getNumberComputed(){
      this.exNum.computedDynamicColumns = []
      this.exNum.computedDataList = []
        let params = {
          scenes: this.sceneIds.join(),
          type: this.exNum.type,
          alarm: this.exNum.alarm
        }
        if(this.exNum.type === 2){
          params.time = this.exNum.computedParams.computedYear + '-' + this.exNum.computedParams.computedMonth

          this.exNum.computedDynamicColumns.push(`${this.exNum.timeParams.month.split('-')[0]}年${this.exNum.timeParams.month.split('-')[1]}月`)
          this.exNum.computedDynamicColumns.push(`${this.exNum.computedParams.computedYear}年${this.exNum.computedParams.computedMonth}月`)

        }else if(this.exNum.type === 3){ // 季度
          params.time = this.exNum.computedParams.computedQuarterYear + '-' + this.exNum.computedParams.computedQuarter

          let label1 = ''
          switch (this.exNum.timeParams.quarter){
            case 1:
              label1 = this.$t('integration.one_quarter')
              break
            case 2:
              label1 = this.$t('integration.two_quarter')
              break
            case 3:
              label1 = this.$t('integration.three_quarter')
              break
            case 4:
              label1 = this.$t('integration.four_quarter')
              break
          }
          let label2 = ''
          switch (this.exNum.computedParams.computedQuarter){
            case 1:
              label2 = this.$t('integration.one_quarter')
              break
            case 2:
              label2 = this.$t('integration.two_quarter')
              break
            case 3:
              label2 = this.$t('integration.three_quarter')
              break
            case 4:
              label2 = this.$t('integration.four_quarter')
              break
          }
          this.exNum.computedDynamicColumns.push(`${this.exNum.timeParams.quarterYear}${this.$t('integration.year')} ${label1}`)
          this.exNum.computedDynamicColumns.push(`${this.exNum.computedParams.computedQuarterYear}${this.$t('integration.year')} ${label2}`)

        }else{
          params.time = this.exNum.computedParams.computedYear

          this.exNum.computedDynamicColumns.push(`${this.exNum.timeParams.year}年`)
          this.exNum.computedDynamicColumns.push(`${this.exNum.computedParams.computedYear}年`)
        }
        console.log('params=', params, this.exNum.computedParams)
        console.log('computedDynamicColumns=================', this.exNum.computedDynamicColumns)
          // this.$refs.computedTable.doLayout()
          this.exNum.isUpdate = !this.exNum.isUpdate

        getExNumList(params).then(res => {
          if (res.state.code === 200) {
            // this.abnormalList = res.result

            // 整合对比的两个table数据
            if(this.exNumList.length){
              this.exNumList.forEach(item => {
                this.exNum.computedDataList.push({
                  exCatalog: item.exCatalog,
                  countList: [{...item}]
                })
              })

              res.result.forEach(item2 => {
                let index = this.exNum.computedDataList.findIndex(_ => _.exCatalog === item2.exCatalog)
                if(index === -1){
                  this.exNum.computedDataList.push({
                    exCatalog: item2.exCatalog,
                    countList: [{}, {...item2}]
                  })
                }else{
                  this.exNum.computedDataList[index].countList.push({...item2})
                }

              })
            }else{
              res.result.forEach(item2 => {
                this.exNum.computedDataList.push({
                    exCatalog: item2.exCatalog,
                    countList: [{}, {...item2}]
                  })
              })
            }


            console.log('computedDataList=',this.exNum.computedDataList)

            // 最后整理computedDataList数据，如果有数据异常，要加上异常最高/低温/湿度，方便table的展示
            // let exNumComputedDataMaxMin =  this.exNum.computedDataList.filter(_ => _.exCatalog === 1)
            // if(exNumComputedDataMaxMin.length){
            //   this.exNum.computedDataList.push({
            //     exCatalog: 'max',
            //     countList:
            //   })
            // }

          }
        })
    },

    // 同比时第一行统计选择改变时
    changeNumberComputed(){
      this.changNumberDataType()
    },

    // 同比时第二行选择改变时
    async changeNumberTimeComputedYear(){
      console.log('changeNumberTimeComputedYear=================', this.computedParams.computedYear)
       await this.getExNum()
        this.getNumberComputed()
    },

    // 过滤无效信息
    filterNumAlarmChange(){
      if(this.exNum.dataType === 1){
        this.getExNum()
      }else{
        this.changNumberDataType()
      }
    },

    // 以下是异常次数的------------------

    // 选择的数据模式改变
    changeTimeType(type){
      this.exTime.type = type
      if(this.exTime.dataType === 1){
        this.getExTime()
      }else{
        this.changTimeDataType()
      }
    },
    changeTimeTime(){
      this.getExTime()
    },
    // 直接统计/同比/环比改变
    async changTimeDataType(){
      if(this.exTime.dataType == 2 ){
        this.exTime.computedParams = JSON.parse(JSON.stringify(this.exTime.timeParams))

        if(this.exTime.type ===2){
          this.$set(this.exTime.computedParams, 'computedYear', parseInt(this.exTime.computedParams.month.split('-')[0]) - 1)
          this.$set(this.exTime.computedParams, 'computedMonth', this.exTime.computedParams.month.split('-')[1])
        }else if(this.exTime.type === 3){
          this.$set(this.exTime.computedParams, 'computedQuarterYear', this.exTime.computedParams.quarterYear - 1)
          this.$set(this.exTime.computedParams, 'computedQuarter', this.exTime.computedParams.quarter)
        }else{
          this.$set(this.exTime.computedParams, 'computedYear', this.exTime.computedParams.year - 1)
        }

      }else if(this.exTime.dataType == 3){
        this.exTime.computedParams = JSON.parse(JSON.stringify(this.exTime.timeParams))
        if(this.exTime.type ===2){
          // 如果是1月环比，就要和上一年的12月比
          if(parseInt(this.exTime.computedParams.month.split('-')[1]) ===  1){
            this.$set(this.exTime.computedParams, 'computedYear', parseInt(this.exTime.computedParams.month.split('-')[0]) - 1)
            this.$set(this.exTime.computedParams, 'computedMonth', 12)
          }else{
            this.$set(this.exTime.computedParams, 'computedYear', this.exTime.computedParams.month.split('-')[0])
            this.$set(this.exTime.computedParams, 'computedMonth', parseInt(this.exTime.computedParams.month.split('-')[1]) - 1)
          }

        }else if(this.exTime.type === 3){
          // 如果是第一季度环比，就是和上一年的第4季度比
          if(this.exTime.computedParams.quarter == 1){
            this.$set(this.exTime.computedParams, 'computedQuarterYear', this.exTime.computedParams.quarterYear - 1)
            this.$set(this.exTime.computedParams, 'computedQuarter', 4)
          }else{
            this.$set(this.exTime.computedParams, 'computedQuarterYear', this.exTime.computedParams.quarterYear)
            this.$set(this.exTime.computedParams, 'computedQuarter', this.exTime.computedParams.quarter - 1)
          }

        }else{
          this.$set(this.exTime.computedParams, 'computedYear', this.exTime.computedParams.year - 1)
        }
      }
      await this.getExTime()
      this.getTimeComputed()
    },
    // 获取对比的另一个数据
    getTimeComputed(){
      this.exTime.computedDynamicColumns = []
      this.exTime.computedDataList = []
        let params = {
          scenes: this.sceneIds.join(),
          type: this.exTime.type,
          alarm: this.exTime.alarm
        }
        if(this.exTime.type === 2){
          params.time = this.exTime.computedParams.computedYear + '-' + this.exTime.computedParams.computedMonth

          this.exTime.computedDynamicColumns.push(`${this.exTime.timeParams.month.split('-')[0]}年${this.exTime.timeParams.month.split('-')[1]}月`)
          this.exTime.computedDynamicColumns.push(`${this.exTime.computedParams.computedYear}年${this.exTime.computedParams.computedMonth}月`)

        }else if(this.exTime.type === 3){ // 季度
          params.time = this.exTime.computedParams.computedQuarterYear + '-' + this.exTime.computedParams.computedQuarter

          let label1 = ''
          switch (this.exTime.timeParams.quarter){
            case 1:
              label1 = this.$t('integration.one_quarter')
              break
            case 2:
              label1 = this.$t('integration.two_quarter')
              break
            case 3:
              label1 = this.$t('integration.three_quarter')
              break
            case 4:
              label1 = this.$t('integration.four_quarter')
              break
          }
          let label2 = ''
          switch (this.exTime.computedParams.computedQuarter){
            case 1:
              label2 = this.$t('integration.one_quarter')
              break
            case 2:
              label2 = this.$t('integration.two_quarter')
              break
            case 3:
              label2 = this.$t('integration.three_quarter')
              break
            case 4:
              label2 = this.$t('integration.four_quarter')
              break
          }
          this.exTime.computedDynamicColumns.push(`${this.exTime.timeParams.quarterYear}${this.$t('integration.year')} ${label1}`)
          this.exTime.computedDynamicColumns.push(`${this.exTime.computedParams.computedQuarterYear}${this.$t('integration.year')} ${label2}`)

        }else{
          params.time = this.exTime.computedParams.computedYear

          this.exTime.computedDynamicColumns.push(`${this.exTime.timeParams.year}年`)
          this.exTime.computedDynamicColumns.push(`${this.exTime.computedParams.computedYear}年`)
        }
        console.log('params=', params, this.exTime.computedParams)
        console.log('computedDynamicColumns=================', this.exTime.computedDynamicColumns)
          // this.$refs.computedTable.doLayout()
          this.exTime.isUpdate = !this.exTime.isUpdate

        getExTimeList(params).then(res => {
          if (res.state.code === 200) {
            // this.abnormalList = res.result

            // 整合对比的两个table数据
            if(this.exTimeList.length){
              this.exTimeList.forEach(item => {
                this.exTime.computedDataList.push({
                  exCatalog: item.exCatalog,
                  countList: [{...item}]
                })
              })

              res.result.forEach(item2 => {
                let index = this.exTime.computedDataList.findIndex(_ => _.exCatalog === item2.exCatalog)
                if(index === -1){
                  this.exTime.computedDataList.push({
                    exCatalog: item2.exCatalog,
                    countList: [{}, {...item2}]
                  })
                }else{
                  this.exTime.computedDataList[index].countList.push({...item2})
                }

              })
            }else{
              res.result.forEach(item2 => {
                this.exTime.computedDataList.push({
                    exCatalog: item2.exCatalog,
                    countList: [{}, {...item2}]
                  })
              })
            }


            console.log('computedDataList=',this.exTime.computedDataList)

          }
        })
    },

    // 同比时第一行统计选择改变时
    changeTimeComputed(){
      this.changTimeDataType()
    },

    // 同比时第二行选择改变时
    async changeTimeComputedYear(){
       await this.getExTime()
        this.getTimeComputed()
    },

    abnormalTypeConvert(type){
      switch(type){
        case 0:
          return this.$t('public.ex_conn')
        case 1:
          return this.$t('public.ex_data')
        case 2:
          return this.$t('public.ex_power')
        case 3:
          return this.$t('public.ex_max_temp_hum')
        case 4:
          return this.$t('public.ex_min_temp_hum')
        case 5:
          return this.$t('public.ex_duration_temp')
        case 6:
          return this.$t('public.ex_duration_hum')
        case 7:
          return this.$t('public.ex_duration_offline')
        case 8:
          return this.$t('public.ex_duration_power')
      }
    },
    // 过滤无效信息
    filterTimeAlarmChange(){
      if(this.exTime.dataType === 1){
        this.getExTime()
      }else{
        this.changTimeDataType()
      }
    },
    handleDetail(exType){
      this.exType = exType
      this.isShowDetail = true

    }

  }

}
</script>
<style lang="scss" scoped>
.btns{
  // width: 100px;
  position: absolute;
  left: -40px;
  top: 25px;
  .el-button{
    width: 80px;
    margin: 5px;
  }
}
.el-row {
  height: 30px;
  line-height: 30px;
  border-bottom: 1px solid #CCCCCC;
  text-align: center;
}
.mt-10{
  margin-top: 10px;
}
.my-td{
    border-right: 1px solid #dfe6ec;
    padding: 0 10px;
    height: 27px;
    line-height: 27px;
}
</style>
